import * as Yup from 'yup';

export const DESCRIPTION_MAX_LENGTH = 5000;

export const CATEGORY_OPTIONS = [
	{
		value: 'Service Request',
		label: 'Service Request',
		tooltip:
			'Change, add or remove existing applicable features (i.e. adding missing clients or form changes)',
	},
	{
		value: 'Folio App Query',
		label: 'Folio Query',
		tooltip:
			'Ask a question on how to use a certain feature/function within the Folio Platform',
	},
	{
		value: 'General Query',
		label: 'General Query',
		tooltip: 'Ask a question about a feature/function/process outside of the Folio Platform',
	},
	{
		value: 'FOLIO App Issue',
		label: 'Folio Bug',
		tooltip: 'Report a feature/function bug within the Folio Platform',
	},
	{
		value: 'Service Issue',
		label: 'Issue',
		tooltip: 'Report an issue that\'s outside of the Folio Platform',
	},
	{
		value: 'FOLIO App Feature Request',
		label: 'Feature Request',
		tooltip: 'Suggest a change or additional feature/function within the Folio Platform',
	},
];

export const AREA_IMPACTED_OPTIONS = [
	{ value: 'Clients', label: 'Clients' },
	{ value: 'Prospects', label: 'Prospects' },
	{ value: 'New Business', label: 'New Business' },
	{ value: 'Renewals', label: 'Renewals' },
	{ value: 'Endorsements', label: 'Endorsements' },
	{ value: 'Debtors', label: 'Debtors' },
	{ value: 'Templates', label: 'Templates' },
	{ value: 'Settings', label: 'Settings' },
	{ value: 'Other', label: 'Other' },
];

// Export validation schema
export const supportTicketValidationSchema = Yup.object().shape({
	subject: Yup.string().required('Subject is required'),
	category: Yup.string().required('Category is required'),
	areaImpacted: Yup.string().required('Area impacted is required'),
	userAffected: Yup.mixed().nullable(),
	description: Yup.string()
		.required('Description is required')
		.max(
			DESCRIPTION_MAX_LENGTH,
			`Description cannot exceed ${DESCRIPTION_MAX_LENGTH} characters`,
		),
	attachments: Yup.array(),
});
